import { render, staticRenderFns } from "./FederationPlanView.vue?vue&type=template&id=55630709&scoped=true"
import script from "./FederationPlanView.vue?vue&type=script&lang=js"
export * from "./FederationPlanView.vue?vue&type=script&lang=js"
import style0 from "./FederationPlanView.vue?vue&type=style&index=0&id=55630709&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55630709",
  null
  
)

export default component.exports